import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AWSService } from '../shared/services/aws.service';
import { ExpiresInPipe } from '../shared/pipes/expires-in.pipe';
import { DurationInputArg2 } from 'moment';

@Component({
  selector: 'app-exports',
  templateUrl: './exports.component.html',
  styleUrls: ['./exports.component.scss'],
  standalone: false
})
export class ExportsComponent implements OnInit {
  isFetchingData = true;
  displayedColumns: string[] = ['filename', 'lastModified', 'expiresIn', 'actions'];
  dataSource = new MatTableDataSource([]);
  expiresInPipe: ExpiresInPipe;

  constructor(private awsService: AWSService) {
    this.expiresInPipe = new ExpiresInPipe();
  }

  ngOnInit(): void {
    this.awsService.listExportDownloads().subscribe(
      (s3Objects) => {
        this.isFetchingData = false;
        this.dataSource = new MatTableDataSource(s3Objects);
      },
      (error) => {
        this.isFetchingData = false;
      }
    );
  }

  expiresInFromLastModify(
    lastModify: string,
    thresholdNumber: number,
    thresholdUnit: DurationInputArg2 = 'days'
  ): string {
    return this.expiresInPipe.transform(lastModify, thresholdNumber, thresholdUnit);
  }

  getS3Object(key: string): void {
    const url = this.awsService.getObjectUrl(key).subscribe((result) => {
      if (result) {
        window.open(result.url, '_blank');
      }
    });
  }

  searchExports(event: string): void {
    this.dataSource.filter = event;
  }
}
